<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X7eFgg/tc-custom/FC-9781528988209.jpg?1685203786252?1709061600829" alt="This image is the cover for the book Alienation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alienation
      </h1>
      <p class="bookDescription body article font2">
        <p>The author lived through two atrocious wars. The first one during his childhood, the war of Algeria’s independence against French colonisation, the second being the Civil War which occurred after independence. These two dramatic events deeply marked his life. They confirm to him that man is not the most perfect being. He is the most dangerous animal which is destined to end himself by creating the conditions leading towards his own alienation and extinction… “…The train now started to pick up speed. Alas! Women and children and even old people could not ride. I read on their faces all the fear, distress, dismay and horror…!”</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Azzedine Kechroud
      </h2>
      
      <p class="authorDescription body article">Azzedine Kechroud was born on 11 February 1946 in Algiers, Algeria. He has a degree in private law. He is a writer, novelist and poet. He started writing when he was young but began publishing later. He lives in England as a British citizen with his family and grandsons. He is retired.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?491508ca